import { API_BASE_URL } from '../config/apiConfig';
import { createSharedResource } from './useSharedResource';

// Reads org-level state the subscription UI gates on (GET /api/v2/organizations/current).
// The modal *dismissal* flags are per-user now — see useCurrentUser for the write side.
// The request is shared across all consumers via createSharedResource, so a page
// with several gates/cards fetches this once rather than once per component.
const resource = createSharedResource(() =>
  fetch(`${API_BASE_URL}/api/v2/organizations/current`, {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' },
  })
    .then(res => (res.ok ? res.json() : null))
    .then(data => (data?.data ? { id: data.data.id, ...data.data.attributes } : null))
);

export function useCurrentOrganization() {
  const { data, loading } = resource.useResource();
  return { org: data, loading };
}
